import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

const ItemQuantityRangeField: React.FC = () => {
    return (
        <Form.Item label={<span className="search-field-label">商品数量</span>}>
            <div style={{ display: "flex" }}>
                <Form.Item name="itemQuantityFrom" className="inline-block" style={{ marginRight: 0 }}>
                    <Input style={{ width: 45 }} />
                </Form.Item>
                <span className="to-label">至</span>
                <Form.Item name="itemQuantityTo" className="inline-block" style={{ marginRight: 0 }}>
                    <Input style={{ width: 45 }} />
                </Form.Item>
            </div>
        </Form.Item>
    );
};

export default React.memo(ItemQuantityRangeField);
